import { Input, ScrollArea, Space, Stack } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { LabelWithHint } from '@/components/ui-shared/LabelWithHint/LabelWithHint'
import { useDeploymentStepperContext } from '../../DeploymentStepperContext'
import { FormValues } from '../DeploymentSettings'
import { ConfidenceSelector } from './ConfidenceSelector/ConfidenceSelector'

type ConfidenceSettingsProps = {
  form: UseFormReturnType<FormValues>
}

export const ConfidenceSettings = ({ form }: ConfidenceSettingsProps) => {
  const { uniqueLabels } = useDeploymentStepperContext()

  // This creates a map that links each label's ID to its name.
  // It's used to quickly find a label's name using its ID.
  const labelMap = useMemo(
    () => new Map(uniqueLabels.map((label) => [label.id, label.name])),
    [uniqueLabels]
  )

  return (
    <Input.Wrapper
      label={
        <LabelWithHint
          label={<FormattedMessage id="events.confidence.title" />}
          hint={
            <FormattedMessage
              id="events.confidence.description"
              values={{ br: <Space h={8} /> }}
            />
          }
        />
      }
    >
      <ScrollArea h={200} scrollbars="y" mt="md">
        <Stack gap="xl" pr="lg" mt="md">
          {form.getValues().confidenceThresholds.map((thresholdObj, index) => (
            <ConfidenceSelector
              key={thresholdObj.label_id}
              labelWidth={120}
              label={labelMap.get(thresholdObj.label_id) || ''}
              value={thresholdObj.threshold}
              onChange={(value) =>
                form.setFieldValue(
                  `confidenceThresholds.${index}.threshold`,
                  value
                )
              }
            />
          ))}
        </Stack>
      </ScrollArea>
    </Input.Wrapper>
  )
}
